<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Pages</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <filter-bar></filter-bar>
      <vuetable
        ref="vuetable"
        :api-url="apiUrl"
        :fields="fields"
        :data="pages"
        pagination-path
        :per-page="10"
        :multi-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="actions" slot-scope="pages">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(pages)">
              <i class="fa fa-edit"></i>
            </button>
            <button class="ui button" @click="deleteModal(pages.rowData.id)">
              <i class="fa fa-remove"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>

    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">Are you sure you want to delete this Page?</div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div
          class="ui positive right labeled icon button"
          @click="pageDelete(id)"
        >
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import SemanticModal from "vue-ya-semantic-modal";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from '@/assets/js/HttpClient'

export default {
  name: "Pages",
  computed: {},
  components: {
    Vuetable,
    VuetablePagination,
    SemanticModal: SemanticModal()
  },
  data() {
    return {
      btnName: "Page",
      route: "Edit Page Details",
      showModal: false,
      id: "",
      fields: [
        {
          name: "id",
          title: "ID",
          sortField: "id"
        },
        {
          name: "name",
          title: "Name",
          sortField: "name"
        },
        // Buttons Column
        "__slot:actions"
      ],
      sortOrder: [
        {
          field: "name",
          sortField: "name",
          direction: "asc"
        }
      ],
      moreParams: {},
      pages: [],
      apiUrl: apiService.getPagesUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers
      }
    };
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());
    this.getPages();
  },
  methods: {
    deleteModal(id) {
      this.showModal = !this.showModal;
      this.page = id;

      return id;
    },
    getPages() {
      apiService.getPages().then(data => {
        this.pages = data;
      });
    },
    goToDetail(page) {
      this.$router.push({
        name: "Edit Page Details",
        params: {
          id: page.rowData.id
        }
      });
    },
    pageDelete() {
      var page = this.page;

      apiService
        .deletepage({ id: page })
        .then(request => {
          this.pageSuccessful(request);
          this.showModal = !this.showModal;
          location.reload();
        })
        .catch(err => this.pageFailed(err));
    },
    pageSuccessful(request) {
      (this.name = request.name),
        (this.content = request.content),
        (this.active = request.active);
    },
    pageFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(filterText) {
      this.moreParams.filter = filterText;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    }
  }
};
</script>

<style module></style>
